// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGBlog = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12.74 3.995H5.76c-.414 0-.75.336-.75.75v1.99c0 .414.336.75.75.75h6.98c.414 0 .75-.336.75-.75v-1.99c0-.414-.336-.75-.75-.75zM5.755 8.48h6.976l.065-.002c.414 0 .75.335.75.75 0 .414-.336.75-.75.75-.022 0-.043-.001-.062-.003H5.752c-.384-.033-.685-.355-.685-.747 0-.393.301-.715.688-.748zM5.755 10.975h6.977c.022-.002.043-.002.065-.002.414 0 .75.335.75.75 0 .414-.336.75-.75.75-.022 0-.043-.002-.062-.003H5.758l-.065.002c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75.022 0 .044.002.062.003z"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26 1.5h9.995C15.22 1.5 16 2.281 16 3.245v8.96c0 1.515-1.23 2.744-2.745 2.744H1.872C.83 14.889.004 14.026 0 12.969V5.737c.033-.383.355-.685.747-.685.393 0 .715.302.748.688v7.23c0 .281.228.51.51.51.282 0 .51-.229.51-.51V3.245c0-.963.781-1.744 1.745-1.744zm8.98 11.96c.686-.003 1.242-.559 1.245-1.245v-8.96c0-.138-.112-.25-.25-.25H4.26c-.138 0-.25.112-.25.25V13.46h9.23z"
  })]
}));
SVGBlog.displayName = 'SVGBlog';
export default SVGBlog;